

import { useState, useEffect } from "react";
import { FaArrowCircleLeft, FaTrash, FaPlusCircle,} from "react-icons/fa";
import { useNavigate ,useLocation } from "react-router-dom";
import axios from "axios";
  import { FaSearch } from "react-icons/fa";
  import { showSuccess, showError, showWarning } from "../../General/Toast";
  import { useMemo } from "react";

function AddEstimate({ clientData ,role}) {

 const navigate = useNavigate();
const location = useLocation();
const editData = location.state;


const [ReturnDate, setReturnDate] = useState(
  new Date().toISOString().split("T")[0]
);
  const [partyName, setPartyName] = useState("");
    const [partyAddress, setPartyAddress] = useState("");
      const [partyGst, setPartyGst] = useState("");
         const [partyNo, setPartyNo] = useState("");
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [returnAgainst, setReturnAgainst] = useState("");
  // const [returnNo, setReturnNo] = useState(clientData?.pur_ret_no || "");

// const [totalTax, setTotalTax] = useState(0);
const [received, setReceived] = useState(0);
const [due, setDue] = useState(0);
  const [unit, setunit] = useState([]);
  const [category, setCategory] = useState([]);
  const [visitParty, setVisitParty] = useState(0);

  const [originalTotalPur, setOriginalTotalPur] = useState(0);
const [previousBalance, setPreviousBalance] = useState(0);
const [isIGSTBill, setIsIGSTBill] = useState(false);
const [estimateDate, setEstimateDate] = useState(
  new Date().toISOString().slice(0, 16)
);

// const [estimateNo, setEstimateNo] = useState(clientData.estimateNo || "");

const [estimateNo, setEstimateNo] = useState("");
const [inventory,setInventory] = useState([]);
const [description, setDescription] = useState("");

useEffect(() => {
  if (editData) {
    setEstimateNo(editData.invoiceNo);
  } else {
    setEstimateNo(clientData?.estimateNo || "");
  }
}, [editData, clientData]);


  const isEditMode = Boolean(editData);

useEffect(() => {
  if (!editData) return;

  setEstimateNo(editData.invoiceNo || "");
  setPartyName(editData.name || "");
  setPartyAddress(editData.address || "");
  setPartyNo(editData.mobile || "");
  setDescription(editData.description || "");
   setEstimateDate(
    editData.date
      ? editData.date.replace(" ", "T").slice(0, 16)
      : new Date().toISOString().slice(0, 16)
  );

  setBillDiscount({
    type: editData.last_discount_type || "percent",
    value: Number(editData.last_discount || 0),
  });

  const parsed =
    typeof editData.items === "string"
      ? JSON.parse(editData.items)
      : editData.items;

  const formattedRows = parsed.map((item, index) => ({
    id: index + 1,
    name: item.name,
    category: item.category,
    unit: item.unit,
    qty: Number(item.quant),
    price: Number(item.price_per_unit),
    discountType: item.dis_type || "percent",
    discountValue: Number(item.discount || 0),
    taxRate: item.taxRate || "",
    taxType: item.sale_price_withTax || "Without Tax",
    amount: Number(item.amount),
  }));

  setRows(formattedRows);

}, [editData]);

const [billDiscount, setBillDiscount] = useState({
  type: "percent",
  value: 0,
});

  const [rows, setRows] = useState([
  {
    id: 1,
    name: "",
    category: "",
    unit: "",
    price: "",
    qty: "",
    taxType: "Without Tax",
    taxRate: "",
    amount: "",
    discountType: "percent",
    discountValue: 0,
  },
  ]);


  const fetchPurchase = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-purchase-bill/${clientData.id}`
      );
      setPurchaseBill(res.data);
    } catch (err) {
      console.log(err);
    }
  };

    const fetchUnit = async () => {
      try {
        const res = await axios.get(`https://api.dectwinbilling.com/fetch-unit/${clientData.id}`);
        setunit(res.data);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    const fetchCategory = async () => {
      try {
        const res = await axios.get(`https://api.dectwinbilling.com/fetch-category/${clientData.id}`);
        const filterCat =
          setCategory(res.data);
  
      } catch (error) {
        console.log(error);
      }
    };

       const fetchInventory = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-inventory/${clientData.id}`);
      setInventory(res.data);

  
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    fetchPurchase();
    fetchCategory();
    fetchUnit();
    fetchInventory();
  }, []);



  
  const addRow = () => {
    setRows([
      ...rows,
      {
      id: rows.length + 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      taxType: "Without Tax",
      taxRate: "",
      amount: "",
      discountType: "percent",
      discountValue: 0,
    },
    ]);
  };

  
const handleRowChange = (index, field, value) => {
  const updated = [...rows];
  updated[index][field] = value;
  setRows(updated);
};

// const handleSelectItem = (index, item) => {
//   if (index === null || index === undefined || !item) {
//     return;
//   }

//   setRows((prevRows) => {
//     const updatedRows = [...prevRows];

//     // Current row fill
//     updatedRows[index] = {
//       ...updatedRows[index],

//       name: item.name || "",
//       category: item.category || "",
//       unit: item.unit || "",

//       price: Number(item.sale_price || 0),

//       taxRate: item.taxRate || "",

//       qty: 1,

//       amount: Number(item.sale_price || 0),

//       // Inventory ID useful for edit/save
//       itemId: item.id,

//       // Extra item data
//       mrp: Number(item.mrp || 0),
//       pur_price: Number(item.pur_price || 0),
//       typeOfItem: item.typeOfItem || "product",
//     };

//     // ✅ Last row select hone par next blank row automatically add
//     if (index === updatedRows.length - 1) {
//       updatedRows.push({
//         id: Date.now(),
//         name: "",
//         category: "",
//         unit: "",
//         price: "",
//         qty: "",
//         taxType: "Without Tax",
//         taxRate: "",
//         amount: "",
//         discountType: "percent",
//         discountValue: 0,
//       });
//     }

//     return updatedRows;
//   });
// };

// const handleSelectItem = (index, item) => {
//   const updatedRows = [...rows];

//   updatedRows[index] = {
//     ...updatedRows[index],

//     name: item.name,
//     category: item.category,
//     unit: item.unit,
//     price: Number(item.sale_price || 0),
//     tax: item.taxRate,
//     qty: 1,
//     amount: Number(item.sale_price || 0) * 1,
//   };

//   setRows(updatedRows);
// };

// const calculateRowAmount = (row) => {
//   const qty = Number(row.qty || 0);
//   const price = Number(row.price || 0);

//   let total = qty * price;

//   // ROW DISCOUNT
//   if (row.discountValue) {
//     if (row.discountType === "percent") {
//       total -= (total * row.discountValue) / 100;
//     } else {
//       total -= Number(row.discountValue);
//     }
//   }

//   return total;
// };


// const calculateRowAmount = (row) => {
//   const qty = Number(row.qty || 0);
//   const price = Number(row.price || 0);

//   let base = qty * price;

//   // discount
//   if (row.discountValue) {
//     if (row.discountType === "percent") {
//       base -= (base * row.discountValue) / 100;
//     } else {
//       base -= Number(row.discountValue);
//     }
//   }

//   // tax
//   const rate = parseFloat(
//     (row.taxRate || "").replace(/[^0-9.]/g, "")
//   ) || 0;

//   if (row.taxType === "Without Tax") {
//     base += (base * rate) / 100;
//   }

//   return base;
// };

const handleSelectItem = (index, item) => {
  if (index === null || index === undefined || !item) {
    return;
  }

  // ✅ Inventory se discount value properly pick karo
  const discountValue =
    item.discount ??
    item.discount_value ??
    item.discountValue ??
    item.dis_value ??
    item.dis_amount ??
    0;

  // ✅ Discount type properly normalize karo
  const rawDiscountType =
    item.dis_in_percent ??
    item.discountType ??
    item.discount_type ??
    item.dis_type ??
    "percent";

  const discountType =
    String(rawDiscountType).toLowerCase().includes("amount")
      ? "amount"
      : "percent";

  setRows((prevRows) => {
    const updatedRows = [...prevRows];

    updatedRows[index] = {
      ...updatedRows[index],

      name: item.name || "",
      category: item.category || "",
      unit: item.unit || "",

      price: Number(item.sale_price || 0),

      qty: 1,

      taxRate: item.taxRate || "",

      amount: Number(item.sale_price || 0),

      itemId: item.id,

      mrp: Number(item.mrp || 0),
      pur_price: Number(item.pur_price || 0),
      typeOfItem: item.typeOfItem || "product",

      // ✅ DISCOUNT AUTOFILL
      discountType: discountType,
      discountValue: Number(discountValue) || 0,
    };

    // Last row select hone par new blank row
    if (index === updatedRows.length - 1) {
      updatedRows.push({
        id: Date.now(),
        name: "",
        category: "",
        unit: "",
        price: "",
        qty: "",
        taxType: "Without Tax",
        taxRate: "",
        amount: "",
        discountType: "percent",
        discountValue: 0,
      });
    }

    return updatedRows;
  });
};
const calculateRowAmount = (row) => {
  const qty = Number(row.qty || 0);
  const price = Number(row.price || 0);

  let base = qty * price;

  // discount
  if (row.discountValue) {
    if (row.discountType === "percent") {
      base -= (base * row.discountValue) / 100;
    } else {
      base -= Number(row.discountValue);
    }
  }

  const rate =
    parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

  // ✅ FIX: tax should depend on With/Without tax
  if (row.taxType === "Without Tax") {
    base += (base * rate) / 100;
  }

  return base;
};


const totalQty = rows.reduce(
  (sum, row) => sum + Number(row.qty || 0),
  0
);




const returnAmount = rows.reduce(
  (sum, row) => sum + Number(row.amount || 0),
  0
);

// const payableAmount = subTotal;

// const subTotal = rows.reduce((sum, row) => {
//   return sum + Number(row.amount || 0);
// }, 0);

const subTotal = useMemo(() => {
  return rows.reduce((sum, row) => {
    return sum + calculateRowAmount(row);
  }, 0);
}, [rows]);



// let discountedTotal = subTotal;

const discountedTotal = useMemo(() => {
  let total = subTotal;

  if (billDiscount.value) {
    if (billDiscount.type === "percent") {
      total -= (subTotal * billDiscount.value) / 100;
    } else {
      total -= Number(billDiscount.value);
    }
  }

  return Math.max(0, total);
}, [subTotal, billDiscount]);


const calculateGST = (rows) => {
  let sgst = 0;
  let cgst = 0;
  let igst = 0;

  rows.forEach((row) => {
    const qty = Number(row.qty || 0);
    const price = Number(row.price || 0);

    let base = qty * price;

    if (row.discountValue) {
      if (row.discountType === "percent") {
        base -= (base * row.discountValue) / 100;
      } else {
        base -= Number(row.discountValue);
      }
    }

    const rate =
      parseFloat((row.taxRate || "").replace(/[^0-9.]/g, "")) || 0;

    const taxAmount = (base * rate) / 100;

    if (!row.taxRate) return;

    if (row.taxRate.startsWith("GST")) {
      sgst += taxAmount / 2;
      cgst += taxAmount / 2;
    } else if (row.taxRate.startsWith("IGST")) {
      igst += taxAmount;
    }
  });

  return {
    sgst,
    cgst,
    igst,
    totalTax: sgst + cgst + igst,
  };
};

// const buildItemsPayload = () => {
//   return rows.map((row, index) => {
//     const qty = Number(row.qty || 0);
//     const price = Number(row.price || 0);

//     const base = qty * price;

//     // discount
//     let discountAmount = 0;
//     if (row.discountType === "percent") {
//       discountAmount = (base * Number(row.discountValue || 0)) / 100;
//     } else {
//       discountAmount = Number(row.discountValue || 0);
//     }

//     const afterDiscount = base - discountAmount;

//     // tax
//     const taxRate = parseFloat(
//       (row.taxRate || "").replace(/[^0-9.]/g, "")
//     ) || 0;

//     const taxAmount =
//       row.taxType === "Without Tax"
//         ? (afterDiscount * taxRate) / 100
//         : 0;

//     const finalAmount = afterDiscount + taxAmount;

//     return {
//       SNo: index + 1,
//       name: row.name,
//       quant: qty,
//       unit: row.unit,
//       price_per_unit: price,
//       discount: row.discountValue || 0,
//       dis_type: row.discountType,
//       taxRate: row.taxRate || "None",
//       taxAmount: Number(taxAmount.toFixed(2)),
//       amount: Number(finalAmount.toFixed(2)),

//       category: row.category || "",
//       pur_price: row.pur_price || 0,
//       mrp: row.mrp || 0,
//       typeOfItem: row.typeOfItem,
//       sale_price_withTax: row.taxType || "Without Tax",

//       stockReducer: ["", row.name, qty],
//     };
//   });
// };

const buildItemsPayload = () => {
  return rows
    // ✅ EMPTY ROW REMOVE
    .filter((row) => {
      return (
        row.name?.trim() &&
        Number(row.qty || 0) > 0
      );
    })
    .map((row, index) => {
      const qty = Number(row.qty || 0);
      const price = Number(row.price || 0);

      const base = qty * price;

      // Discount
      let discountAmount = 0;

      if (row.discountType === "percent") {
        discountAmount =
          (base * Number(row.discountValue || 0)) / 100;
      } else {
        discountAmount =
          Number(row.discountValue || 0);
      }

      const afterDiscount =
        Math.max(0, base - discountAmount);

      // Tax
      const taxRate =
        parseFloat(
          (row.taxRate || "").replace(/[^0-9.]/g, "")
        ) || 0;

      const taxAmount =
        row.taxType === "Without Tax"
          ? (afterDiscount * taxRate) / 100
          : 0;

      const finalAmount =
        afterDiscount + taxAmount;

      return {
        SNo: index + 1,
        name: row.name,
        quant: qty,
        unit: row.unit,
        price_per_unit: price,

        discount: Number(row.discountValue || 0),
        dis_type: row.discountType || "percent",

        taxRate: row.taxRate || "None",
        taxAmount: Number(taxAmount.toFixed(2)),
        amount: Number(finalAmount.toFixed(2)),

        category: row.category || "",
        pur_price: row.pur_price || 0,
        mrp: row.mrp || 0,
        typeOfItem: row.typeOfItem || "product",
        sale_price_withTax:
          row.taxType || "Without Tax",

        stockReducer: ["", row.name, qty],
      };
    });
};


// const handleSaveEstimnate = async () => {
//   try {
//     const itemsPayload = buildItemsPayload();
//     const { sgst, cgst, igst, totalTax } = calculateGST(rows);

//     const payload = {
//       invoice: estimateNo,
//       cust_name: partyName,
//       cust_address: partyAddress,
//       cust_number: partyNo,
//       date: estimateDate,

//       items: itemsPayload,

//       payable: payableAmount,
//       totalSP: payableAmount,

//       sgst: Number(sgst.toFixed(2)),
//       cgst: Number(cgst.toFixed(2)),
//       igst: Number(igst.toFixed(2)),
//       totalTax: Number(totalTax.toFixed(2)),

//       last_discount: billDiscount.value,
//       last_discount_type: billDiscount.type,
//       onChangeForDiscount: "",

//       description,
//       client_type: role,
//     };

//     let res;

//     if (isEditMode) {
//       // Update existing estimate
//       res = await axios.put(
//         `https://api.dectwinbilling.com/update-estimate-bill/${clientData.id}`,
//         payload
//       );

//       showSuccess("Estimate updated successfully");
//         navigate("/estimate-history");
//     } else {
//       // Create new estimate
      
//       res = await axios.post(
//         `https://api.dectwinbilling.com/estimate-bill/${clientData.id}`,
//         payload
//       );

//       if (res.status === 200) {
//         const nextEstimateNo = Number(estimateNo) + 1;

//         await axios.put(
//           `https://api.dectwinbilling.com/update-estimate-no/${clientData.id}`,
//           {
//             estimate_no: nextEstimateNo,
//           }
//         );

//         setEstimateNo(nextEstimateNo);

//         localStorage.setItem(
//           "user_data",
//           JSON.stringify({
//             ...clientData,
//             estimateNo: nextEstimateNo,
//           })
//         );
//       }

//        navigate("/invoice-preview", {
//     state: {
//       invoice: {
//         ...payload,
//         invoiceNo:
//           res.data?.invoiceNo ||
//           res.data?.data?.invoiceNo
//       },
//           billTitle: "ESTIMATE BILL"
//     }
//   });

//       showSuccess("Estimate saved successfully");
//     }

//     resetForm();
  

//   } catch (err) {
//     console.error(err);

//     showError(
//       isEditMode
//         ? "Failed to update estimate"
//         : "Failed to save estimate"
//     );
//   }
// };
const handleSaveEstimnate = async () => {
  try {
    // ✅ Build only valid items
    const itemsPayload = buildItemsPayload();

    // ✅ Empty rows / no item = don't save or print
    if (!itemsPayload || itemsPayload.length === 0) {
      showWarning(
        "Please select at least one item before printing.",
        "warning"
      );
      return;
    }

    // ✅ Calculate GST only from valid rows
    const validRows = rows.filter(
      (row) =>
        row.name?.trim() &&
        Number(row.qty || 0) > 0
    );

    const {
      sgst,
      cgst,
      igst,
      totalTax,
    } = calculateGST(validRows);

    // ✅ Calculate subtotal from valid rows only
    const validSubTotal = validRows.reduce(
      (sum, row) => {
        return sum + calculateRowAmount(row);
      },
      0
    );

    // ✅ Bill discount
    let validDiscountedTotal = validSubTotal;

    if (billDiscount.value) {
      if (billDiscount.type === "percent") {
        validDiscountedTotal =
          validSubTotal -
          (validSubTotal * Number(billDiscount.value || 0)) /
            100;
      } else {
        validDiscountedTotal =
          validSubTotal -
          Number(billDiscount.value || 0);
      }
    }

    validDiscountedTotal = Math.max(
      0,
      validDiscountedTotal
    );

    const validPayableAmount =
      validDiscountedTotal + totalTax;

    // ✅ Final payload
    const payload = {
      invoice: estimateNo,

      cust_name: partyName,
      cust_address: partyAddress,
      cust_number: partyNo,

      date: estimateDate,

      // ✅ ONLY SELECTED ITEMS
      items: itemsPayload,

      payable: Number(
        validPayableAmount.toFixed(2)
      ),

      totalSP: Number(
        validPayableAmount.toFixed(2)
      ),

      sgst: Number(sgst.toFixed(2)),
      cgst: Number(cgst.toFixed(2)),
      igst: Number(igst.toFixed(2)),
      totalTax: Number(totalTax.toFixed(2)),

      last_discount: Number(
        billDiscount.value || 0
      ),

      last_discount_type:
        billDiscount.type || "percent",

      onChangeForDiscount: "",

      description,
      client_type: role,
    };

    let res;

    // =====================================================
    // EDIT ESTIMATE
    // =====================================================

    if (isEditMode) {
      res = await axios.put(
        `https://api.dectwinbilling.com/update-estimate-bill/${clientData.id}`,
        payload
      );

      showSuccess(
        "Estimate updated successfully"
      );

      navigate("/estimate-history");

    } else {

      // =====================================================
      // NEW ESTIMATE
      // =====================================================

      res = await axios.post(
        `https://api.dectwinbilling.com/estimate-bill/${clientData.id}`,
        payload
      );

      // ✅ Update next estimate number
      if (res.status === 200) {
        const nextEstimateNo =
          Number(estimateNo) + 1;

        await axios.put(
          `https://api.dectwinbilling.com/update-estimate-no/${clientData.id}`,
          {
            estimate_no: nextEstimateNo,
          }
        );

        setEstimateNo(nextEstimateNo);

        localStorage.setItem(
          "user_data",
          JSON.stringify({
            ...clientData,
            estimateNo: nextEstimateNo,
          })
        );
      }

      // =====================================================
      // PREVIEW / PRINT
      // =====================================================

      navigate("/invoice-preview", {
        state: {
          invoice: {
            ...payload,

            invoiceNo:
              res.data?.invoiceNo ||
              res.data?.data?.invoiceNo ||
              estimateNo,
          },

          billTitle: "ESTIMATE BILL",
        },
      });

      showSuccess(
        "Estimate saved successfully"
      );
    }

    // ✅ Reset after successful save
    resetForm();

  } catch (err) {
    console.error(
      "Save Estimate Error:",
      err
    );

    showError(
      isEditMode
        ? "Failed to update estimate"
        : "Failed to save estimate"
    );
  }
};
const { sgst, cgst, igst, totalTax } = useMemo(() => {
  return calculateGST(rows);
}, [rows]);


const payableAmount = discountedTotal + totalTax;

const resetForm = () => {
  setReturnDate(new Date().toISOString().split("T")[0]);

  setPartyName("");
  setPartyAddress("");
  setPartyGst("");
  setPartyNo("");

  setReturnAgainst("");

  // setTotalTax(0);
  setReceived(0);
  setDue(0);

  setVisitParty(0);
  setOriginalTotalPur(0);
  setPreviousBalance(0);

  setRows([
    {
      id: 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      tax: "",
      amount: "",
      taxMode: "GST",
      taxRate: 0,
      taxType: "Without Tax",
    },
  ]);
};

  return (
    <div>
       <div className="page-wrapper">

       <div className="page-content">

      <div className="page-header">
        <FaArrowCircleLeft
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/home")}
        />
        Estimate
      </div>

      <div className="container-fluid mt-3">
        <div className="row g-3">

       
          <div className="col-md-4">
        
<div
  className=" p-4 rounded shadow-sm"
  style={{ width: "300px" ,backgroundColor:'var(--card-color)' }}
>
  {/* Estimate No */}
  <div className="mb-3 position-relative">
    <input
      type="text"
      readOnly
      className="form-control"
      style={{ paddingLeft: "115px" }}
        value={estimateNo}
    />
    <span
      className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
    >
      Estimate No:
    </span>

 
  </div>

  {/* Estimate Date */}
  <div className="position-relative ">
    <input
      type="datetime-local"
      className="form-control"
      style={{ paddingLeft: "115px" }}
        value={estimateDate}
  onChange={(e) => setEstimateDate(e.target.value)}
    />
    <span
      className="position-absolute top-50 start-0 translate-middle-y ms-1 fw-medium"
      style={{ pointerEvents: "none" }}
    >
      Estimate Date:
    </span>
  </div>
</div>
          </div>

    

<div className="col-md-4 ms-auto">

  <div className="d-flex align-items-center mb-2">
    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
      Customer Name:
    </span>
    <input
  className="form-control"
  value={partyName}
  onChange={(e) => setPartyName(e.target.value)}
  required
/>
  </div>

  <div className="d-flex align-items-center mb-2">
    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
      Mobile Number:
    </span>
  <input
  className="form-control"
  value={partyNo}
  onChange={(e) => setPartyNo(e.target.value)}
  required
/>
  </div>

  <div className="d-flex align-items-center">
    <span className="me-2 flex-shrink-0 fw-medium" style={{ width: "130px" }}>
      Address:
    </span>
  <input
  className="form-control"
  value={partyAddress}
  onChange={(e) => setPartyAddress(e.target.value)}
  required
/>
  </div>

</div>

        </div>
      </div>

      <div className="container-fluid mt-3">
        <div className="table-wrapper p-2">

          <table className="table table-bordered custom-table mb-0">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Item</th>
                   <th>Qty</th>
          
                <th>Unit</th>
                <th>Price/Unit</th>
                <th>Discount</th>
                <th>Tax</th>
                <th>Amount</th>
              </tr>
            </thead>

    <tbody>
  {rows.map((row, index) => (
    <tr key={row.id}>
      <td>
        <div className="d-flex align-items-center gap-2">
          <span>{index + 1}</span>

          <FaTrash
            color="red"
            style={{ cursor: "pointer" }}
            onClick={() =>
              setRows(rows.filter((_, i) => i !== index))
            }
          />
        </div>
      </td>

<td>
  <select
  className="form-select form-select-sm"
    style={{ minWidth: "120px" }}
  value={row.name}
  onChange={(e) => {
    const item = inventory.find(
      (inv) => inv.name === e.target.value
    );

    if (item) {
      handleSelectItem(index, item);
    }
  }}
>
  <option value="">Select Item</option>

  {inventory.map((item) => (
    <option
      key={item.id}
      
      value={item.name}
    >
      {item.name}
      
    </option>
  ))}
</select>
  {/* <select
    className="form-select form-select-sm"
    value={row.name}
    onChange={(e) => {
      const item = inventory.find(
        (inv) => inv.name === e.target.value
      );

      if (item) {
        handleSelectItem(index, item);
      }
    }}
  >
    <option value="">Select Item</option>

    {inventory.map((item) => (
      <option key={item.id} value={item.name}>
        {item.name}
      </option>
    ))}
  </select> */}
</td>



<td>
<input
  type="number"
  className="form-control form-control-sm"
    style={{ minWidth: "90px" }}
  value={row.qty || ""}
  onChange={(e) => {
    const updatedRows = [...rows];

    const qty = Number(e.target.value) || 0;
    const price = Number(updatedRows[index].price) || 0;

    updatedRows[index].qty = qty;
    // updatedRows[index].amount = qty * price;
    // updatedRows[index].amount = calculateRowAmount(updatedRows[index]);
    setRows(updatedRows);
  }}
/>
</td>



<td>
  <select
    className="form-select form-select-sm"
        style={{ minWidth: "120px" }}
    value={row.unit || ""}
    onChange={(e) => {
      const updatedRows = [...rows];
      updatedRows[index].unit = e.target.value;
      setRows(updatedRows);
    }}
  >
    <option value="">Select Unit</option>

    {unit.map((u) => (
      <option
        key={u.id}
        value={u.cat_name}
      >
        {u.cat_name}
      </option>
    ))}
  </select>
</td>


<td>
<input
  type="number"
  className="form-control form-control-sm"
  value={row.price || ""}
  onChange={(e) => {
    const updatedRows = [...rows];

    const price = Number(e.target.value) || 0;
    const qty = Number(updatedRows[index].qty) || 0;

    updatedRows[index].price = price;
    // updatedRows[index].amount = qty * price;
// updatedRows[index].amount = calculateRowAmount(updatedRows[index]);
    setRows(updatedRows);
  }}
/>
</td>


<td>
  <div className="d-flex gap-2 align-items-center">

 <select
  className="form-select"
  style={{ minWidth: "140px" }}
  value={row.discountType}
  onChange={(e) => {
    const updated = [...rows];
    updated[index].discountType = e.target.value;

    // updated[index].amount = calculateRowAmount(updated[index]);

    setRows(updated);
  }}
>
  <option value="percent">Percent (%)</option>
  <option value="amount">Amount (₹)</option>
</select>


<input
  type="number"
  className="form-control"
  style={{
    width: "100px",
    minWidth: "100px"
  }}
  value={row.discountValue || ""}
  onChange={(e) => {
    const updated = [...rows];

    updated[index].discountValue =
      e.target.value === ""
        ? ""
        : Number(e.target.value);

    setRows(updated);
  }}
/>

  </div>
</td>

<td>
  <div className="d-flex gap-2">

    {/* Tax Type (Disabled) */}
   <select
  className="form-select form-select-sm"
  style={{ width: "120px" }}
  value={row.taxType}
  onChange={(e) => {
    const updated = [...rows];
    updated[index].taxType = e.target.value;

    // updated[index].amount = calculateRowAmount(updated[index]);

    setRows(updated);
  }}
>
  <option value="With Tax">With Tax</option>
  <option value="Without Tax">Without Tax</option>
</select>
<select
  className="form-select form-select-sm"
  style={{ width: "140px" }}
  value={row.taxRate}
  onChange={(e) => {
    const updated = [...rows];

    const value = e.target.value;
    updated[index].taxRate = value;

    // updated[index].amount = calculateRowAmount(updated[index]);

    setRows(updated);
  }}
>
  <option value="">Tax Rate</option>

  <option value="GST 0%">GST 0%</option>
  <option value="IGST 0%">IGST 0%</option>

  <option value="GST 0.25%">GST 0.25%</option>
  <option value="IGST 0.25%">IGST 0.25%</option>

  <option value="GST 3%">GST 3%</option>
  <option value="IGST 3%">IGST 3%</option>

  <option value="GST 5%">GST 5%</option>
  <option value="IGST 5%">IGST 5%</option>

  <option value="GST 12%">GST 12%</option>
  <option value="IGST 12%">IGST 12%</option>

  <option value="GST 18%">GST 18%</option>
  <option value="IGST 18%">IGST 18%</option>

  <option value=">GST 28%">GST 28%</option>
  <option value="IGST 28%">IGST 28%</option>
</select>

  </div>
</td>

{/* <td>₹ {Number(row.amount || 0).toFixed(2)}</td> */}
<td>
  ₹ {calculateRowAmount(row).toFixed(2)}
</td>

    </tr>
  ))}
</tbody>

          </table>

          <div className="text-center mt-2">
            <FaPlusCircle
              size={35}
              color="var(--primary-color)"
              style={{ cursor: "pointer" }}
              onClick={addRow}
            />
          </div>

        </div>
      </div>

      <div className="container-fluid mt-3">
      <div className="summary-box">
  <div className="summary-left">
    <strong>Total</strong>
  </div>

  <div className="summary-right">
    <div>{totalQty} </div>
    <div></div>
      <div></div>
        <div></div>
          <div></div>
            <div></div>
    <div> ₹ {totalTax.toFixed(2)}</div>
    <div>₹ {subTotal}</div>
  </div>
</div>
      </div>

<div className="container-fluid mt-3 mb-3">
  <div className="row align-items-stretch">

    {/* Discount Card */}
<div className="col-md-4">
  <div
    className="card p-3"
    style={{ backgroundColor: "var(--card-color)" }}
  >
    {/* Discount */}
    <h6 className="fw-bold mb-3 text-primary">Discount</h6>

    <div className="d-flex gap-2 mb-4">
    <select
  className="form-select"
  style={{ minWidth: "140px" }}
  value={billDiscount.type}
  onChange={(e) =>
    setBillDiscount({ ...billDiscount, type: e.target.value })
  }
>
  <option value="percent">Percent (%)</option>
  <option value="amount">Amount (₹)</option>
</select>

<input
  type="number"
  className="form-control"
  value={billDiscount.value}
  onChange={(e) =>
    setBillDiscount({
      ...billDiscount,
      value: Number(e.target.value),
    })
  }
/>

   
    </div>

    {/* Description */}
    <h6 className="fw-bold mb-2 text-primary">Description</h6>

 <textarea
  className="form-control"
  rows="4"
  placeholder="Enter description..."
  value={description}
  onChange={(e) => setDescription(e.target.value)}
/>
  </div>
</div>

     <div className="col-md-4">

     </div>

  
    <div className="col-md-4">
      <div className="card p-2 " style={{ backgroundColor: "var(--card-color)" }}>
        <div className="d-flex justify-content-between align-items-center bg-light border rounded-3 p-1" >
          <span className="fw-medium fs-5">
            Payable Amount
          </span>

          <span className="fw-bold fs-4 text-success">
            ₹  {payableAmount.toFixed(2)}
          </span>
        </div>
      </div>
    </div>

  </div>
</div>
  
 </div>
 
 <div className="footer-bar mt-4">
    <button className="btn-clear btn btn-secondary" onClick={() => resetForm()} >Clear Bill</button>
    <button className="btn-save btn btn-success" onClick={handleSaveEstimnate} >Save & Print</button>
    <button className="btn-preview btn btn-primary" onClick={handleSaveEstimnate} >Preview & Share</button>
  </div>

    </div>
    </div>
  )
}

export default AddEstimate
